import type { GetStoresParams, GetStoresResponse } from '@lotta/shared/types-lottery-api';
import { apis } from './apis';

const storesApis = apis.injectEndpoints({
  endpoints: (build) => ({
    getStores: build.query<GetStoresResponse, GetStoresParams>({
      query: ({ retailUnit, language }) => `/${retailUnit}/stores/${language}`,
    }),
  }),
});

export const { useGetStoresQuery } = storesApis;
